import React from 'react';
import { Upload, FileText, Calendar, Clock, CheckCircle2, ChevronDown, Wallet, DollarSign, TrendingUp, BarChart3, Building2, Info } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// Card Revenue Data (Monthly Revenue in Millions, Jan-22 to Mar-25)
const cardRevenueData = [{
  month: 'Jan-22',
  revenue: 3.2
}, {
  month: 'Feb-22',
  revenue: 3.3
}, {
  month: 'Mar-22',
  revenue: 3.4
}, {
  month: 'Apr-22',
  revenue: 3.3
}, {
  month: 'May-22',
  revenue: 3.5
}, {
  month: 'Jun-22',
  revenue: 3.5
}, {
  month: 'Jul-22',
  revenue: 3.6
}, {
  month: 'Aug-22',
  revenue: 3.6
}, {
  month: 'Sep-22',
  revenue: 3.7
}, {
  month: 'Oct-22',
  revenue: 3.7
}, {
  month: 'Nov-22',
  revenue: 3.8
}, {
  month: 'Dec-22',
  revenue: 3.8
}, {
  month: 'Jan-23',
  revenue: 3.5
}, {
  month: 'Feb-23',
  revenue: 3.6
}, {
  month: 'Mar-23',
  revenue: 3.7
}, {
  month: 'Apr-23',
  revenue: 3.6
}, {
  month: 'May-23',
  revenue: 3.7
}, {
  month: 'Jun-23',
  revenue: 3.8
}, {
  month: 'Jul-23',
  revenue: 3.9
}, {
  month: 'Aug-23',
  revenue: 3.8
}, {
  month: 'Sep-23',
  revenue: 4.0
}, {
  month: 'Oct-23',
  revenue: 4.0
}, {
  month: 'Nov-23',
  revenue: 4.1
}, {
  month: 'Dec-23',
  revenue: 4.1
}, {
  month: 'Jan-24',
  revenue: 3.8
}, {
  month: 'Feb-24',
  revenue: 3.8
}, {
  month: 'Mar-24',
  revenue: 4.0
}, {
  month: 'Apr-24',
  revenue: 3.9
}, {
  month: 'May-24',
  revenue: 4.0
}, {
  month: 'Jun-24',
  revenue: 4.1
}, {
  month: 'Jul-24',
  revenue: 4.2
}, {
  month: 'Aug-24',
  revenue: 4.1
}, {
  month: 'Sep-24',
  revenue: 4.3
}, {
  month: 'Oct-24',
  revenue: 4.3
}, {
  month: 'Nov-24',
  revenue: 4.4
}, {
  month: 'Dec-24',
  revenue: 4.4
}, {
  month: 'Jan-25',
  revenue: 4.1
}, {
  month: 'Feb-25',
  revenue: 4.2
}, {
  month: 'Mar-25',
  revenue: 4.3
}];
// Days Beyond Terms Data
const dbtData = [{
  month: 'Oct-24',
  dbt: 7,
  industry: 12,
  yourAR: 3
}, {
  month: 'Nov-24',
  dbt: 6,
  industry: 11,
  yourAR: 2
}, {
  month: 'Dec-24',
  dbt: 5,
  industry: 10,
  yourAR: 2
}, {
  month: 'Jan-25',
  dbt: 10,
  industry: 10,
  yourAR: 4
}, {
  month: 'Feb-25',
  dbt: 8,
  industry: 9,
  yourAR: 3
}, {
  month: 'Mar-25',
  dbt: 6,
  industry: 9,
  yourAR: 2
}, {
  month: 'Apr-25',
  dbt: 9,
  industry: 9,
  yourAR: 3
}, {
  month: 'May-25',
  dbt: 8,
  industry: 9,
  yourAR: 2
}, {
  month: 'Jun-25',
  dbt: 7,
  industry: 9,
  yourAR: 2
}, {
  month: 'Jul-25',
  dbt: 7,
  industry: 9,
  yourAR: 3
}, {
  month: 'Aug-25',
  dbt: 11,
  industry: 10,
  yourAR: 4
}];
// Trade Payment Aging Data
const paidData = [{
  name: 'Current',
  value: 28500000
}, {
  name: '1-30',
  value: 1200000
}, {
  name: '31-60',
  value: 85000
}, {
  name: '61-90',
  value: 12000
}, {
  name: '91+',
  value: 3000
}];
const outstandingData = [{
  name: 'Current',
  value: 1650000
}, {
  name: '1-30',
  value: 180000
}, {
  name: '31-60',
  value: 15000
}, {
  name: '61-90',
  value: 5000
}, {
  name: '91+',
  value: 0
}];
// Trade Spend by Industry Data
const tradeSpendData = [{
  name: 'Paper & Pulp Manufacturing',
  value: 777000,
  color: '#4f46e5',
  percentage: 42
}, {
  name: 'Office Supplies & Equipment',
  value: 333000,
  color: '#10b981',
  percentage: 18
}, {
  name: 'Transportation & Logistics',
  value: 278000,
  color: '#8b5cf6',
  percentage: 15
}, {
  name: 'Printing Services',
  value: 185000,
  color: '#f59e0b',
  percentage: 10
}, {
  name: 'Administrative Services',
  value: 148000,
  color: '#ec4899',
  percentage: 8
}, {
  name: 'IT & Technology',
  value: 74000,
  color: '#06b6d4',
  percentage: 4
}, {
  name: 'Other',
  value: 56000,
  color: '#9ca3af',
  percentage: 3
}];
// Payment Aging by Industry Data
const paymentAgingData = [{
  industry: 'Paper & Pulp Manufacturing',
  total: '$777K',
  trades: 12,
  current: 92,
  days1to30: 6,
  days31to60: 2,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Office Supplies & Equipment',
  total: '$333K',
  trades: 35,
  current: 95,
  days1to30: 5,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Transportation & Logistics',
  total: '$278K',
  trades: 42,
  current: 88,
  days1to30: 8,
  days31to60: 3,
  days61to90: 1,
  days91plus: 0
}, {
  industry: 'Printing Services',
  total: '$185K',
  trades: 18,
  current: 90,
  days1to30: 7,
  days31to60: 3,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Administrative Services',
  total: '$148K',
  trades: 22,
  current: 94,
  days1to30: 6,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'IT & Technology',
  total: '$74K',
  trades: 8,
  current: 100,
  days1to30: 0,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Other',
  total: '$56K',
  trades: 5,
  current: 93,
  days1to30: 7,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}];
export function FinancialsTab() {
  return <div className="space-y-8 mt-8" data-id="element-939">
      {/* Financial Statement Analysis */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-940">
        <div className="flex justify-between items-start mb-8" data-id="element-941">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-942">
            Financial Statement Analysis
          </h2>
          <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2.5 rounded-lg flex items-center gap-2 font-medium text-sm transition-colors" data-id="element-943">
            <Upload className="w-4 h-4" data-id="element-944" />
            UPLOAD FINANCIAL STATEMENT
          </button>
        </div>

        {/* Financial Statement Box */}
        <div className="border border-gray-200 bg-gray-50 rounded-lg p-5 mb-8" data-id="element-945">
          <p className="text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-946">
            Latest Financial Statement
          </p>
          <div className="flex items-center justify-between bg-white p-4 rounded border border-gray-200 shadow-sm" data-id="element-947">
            <div className="flex items-center gap-6" data-id="element-948">
              <div className="flex items-center gap-3" data-id="element-949">
                <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center" data-id="element-950">
                  <FileText className="w-5 h-5 text-indigo-600" data-id="element-951" />
                </div>
                <span className="font-semibold text-gray-900 text-lg" data-id="element-952">
                  DM-Financial-Statement-2025-Q1
                </span>
              </div>
              <div className="h-6 w-px bg-gray-300" data-id="element-953"></div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-954">
                <Calendar className="w-4 h-4" data-id="element-955" />
                <span className="font-medium" data-id="element-956">2025</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-957">
                <Clock className="w-4 h-4" data-id="element-958" />
                <span className="font-medium" data-id="element-959">Q1</span>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-960">
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full border border-green-200" data-id="element-961">
                <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-962" />
                <span className="text-green-700 font-medium text-sm" data-id="element-963">
                  Completed
                </span>
              </div>
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-964">
                <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-965" />
              </button>
            </div>
          </div>
        </div>

        {/* Ratio Cards - All 5 in one row */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-966">
          {/* Liquidity Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-967">
            <div className="flex items-center gap-2 mb-4" data-id="element-968">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center" data-id="element-969">
                <Wallet className="w-4 h-4 text-blue-600" data-id="element-970" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-971">Liquidity</h3>
            </div>
            <div className="space-y-3" data-id="element-972">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-973">
                <span className="text-xs text-gray-600" data-id="element-974">Current Ratio</span>
                <span className="font-bold text-sm text-green-600" data-id="element-975">2.85</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-976">
                <span className="text-xs text-gray-600" data-id="element-977">Quick Ratio</span>
                <span className="font-bold text-sm text-green-600" data-id="element-978">2.41</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-979">
                <span className="text-xs text-gray-600" data-id="element-980">Working Capital</span>
                <span className="font-bold text-sm text-green-600" data-id="element-981">$8.6M</span>
              </div>
            </div>
          </div>

          {/* Cash Flow Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-982">
            <div className="flex items-center gap-2 mb-4" data-id="element-983">
              <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center" data-id="element-984">
                <DollarSign className="w-4 h-4 text-green-600" data-id="element-985" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-986">Cash Flow</h3>
            </div>
            <div className="space-y-3" data-id="element-987">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-988">
                <span className="text-xs text-gray-600" data-id="element-989">Op. Cash Flow</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-990">1.52</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-991">
                <span className="text-xs text-gray-600" data-id="element-992">Free Cash Flow</span>
                <span className="font-bold text-sm text-green-600" data-id="element-993">$2.4M</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-994">
                <span className="text-xs text-gray-600" data-id="element-995">CF Coverage</span>
                <span className="font-bold text-sm text-green-600" data-id="element-996">12.35</span>
              </div>
            </div>
          </div>

          {/* Profitability Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-997">
            <div className="flex items-center gap-2 mb-4" data-id="element-998">
              <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center" data-id="element-999">
                <TrendingUp className="w-4 h-4 text-purple-600" data-id="element-1000" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1001">Profitability</h3>
            </div>
            <div className="space-y-2" data-id="element-1002">
              <div className="flex justify-between items-center border-b border-gray-100 pb-1.5" data-id="element-1003">
                <span className="text-xs text-gray-600" data-id="element-1004">Net Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1005">0.08</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-1.5" data-id="element-1006">
                <span className="text-xs text-gray-600" data-id="element-1007">ROE</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1008">0.18</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-1.5" data-id="element-1009">
                <span className="text-xs text-gray-600" data-id="element-1010">Gross Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1011">0.32</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-1.5" data-id="element-1012">
                <span className="text-xs text-gray-600" data-id="element-1013">Op. Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1014">0.12</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1015">
                <span className="text-xs text-gray-600" data-id="element-1016">ROA</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1017">0.09</span>
              </div>
            </div>
          </div>

          {/* Efficiency Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1018">
            <div className="flex items-center gap-2 mb-4" data-id="element-1019">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center" data-id="element-1020">
                <BarChart3 className="w-4 h-4 text-orange-600" data-id="element-1021" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1022">Efficiency</h3>
            </div>
            <div className="space-y-3" data-id="element-1023">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1024">
                <span className="text-xs text-gray-600" data-id="element-1025">Inv. Turnover</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1026">8.50</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1027">
                <span className="text-xs text-gray-600" data-id="element-1028">AR Turnover</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1029">10.20</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1030">
                <span className="text-xs text-gray-600" data-id="element-1031">DSO</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-1032">35.78</span>
              </div>
            </div>
          </div>

          {/* Solvency Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1033">
            <div className="flex items-center gap-2 mb-4" data-id="element-1034">
              <div className="w-8 h-8 bg-teal-50 rounded-lg flex items-center justify-center" data-id="element-1035">
                <Building2 className="w-4 h-4 text-teal-600" data-id="element-1036" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1037">Solvency</h3>
            </div>
            <div className="space-y-3" data-id="element-1038">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1039">
                <span className="text-xs text-gray-600" data-id="element-1040">Debt-to-Equity</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-1041">0.65</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1042">
                <span className="text-xs text-gray-600" data-id="element-1043">Z-Score</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1044">3.42</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1045">
                <span className="text-xs text-gray-600" data-id="element-1046">Int. Coverage</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1047">18.50</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Card Revenue Metrics */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-1048">
        <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-1049">
          Card Revenue Metrics
        </h2>

        {/* Summary Stats - Flex layout for better spacing */}
        <div className="flex flex-wrap justify-between items-center gap-6 mb-10 bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1050">
          <div className="flex flex-col" data-id="element-1051">
            <span className="text-3xl font-black text-gray-900 mb-1" data-id="element-1052">
              $5.1M
            </span>
            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-1053">
              Annual Card Revenue
            </span>
          </div>
          <div className="w-px h-12 bg-gray-200 hidden md:block" data-id="element-1054"></div>
          <div className="flex flex-col" data-id="element-1055">
            <span className="text-3xl font-black text-gray-900 mb-1" data-id="element-1056">6.8K</span>
            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-1057">
              Transactions
            </span>
          </div>
          <div className="w-px h-12 bg-gray-200 hidden md:block" data-id="element-1058"></div>
          <div className="flex flex-col" data-id="element-1059">
            <span className="text-3xl font-black text-gray-900 mb-1" data-id="element-1060">$750</span>
            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-1061">
              Avg Ticket Size
            </span>
          </div>
          <div className="w-px h-12 bg-gray-200 hidden md:block" data-id="element-1062"></div>
          <div className="flex flex-col" data-id="element-1063">
            <span className="text-3xl font-black text-gray-900 mb-1" data-id="element-1064">
              0 - 28
            </span>
            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-1065">
              Daily Transactions
            </span>
          </div>
          <div className="w-px h-12 bg-gray-200 hidden md:block" data-id="element-1066"></div>
          <div className="flex flex-col" data-id="element-1067">
            <span className="text-3xl font-black text-green-600 mb-1" data-id="element-1068">+6%</span>
            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-1069">
              YoY Growth
            </span>
          </div>
        </div>

        {/* Area Chart */}
        <div className="h-80 w-full" data-id="element-1070">
          <ResponsiveContainer width="100%" height="100%" data-id="element-1071">
            <AreaChart data={cardRevenueData} margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 0
          }} data-id="element-1072">
              <defs data-id="element-1073">
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1" data-id="element-1074">
                  <stop offset="5%" stopColor="#4f46e5" stopOpacity={0.3} data-id="element-1075" />
                  <stop offset="95%" stopColor="#4f46e5" stopOpacity={0} data-id="element-1076" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1077" />
              <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} interval={3} dy={10} data-id="element-1078" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 8]} ticks={[0, 2, 4, 6, 8]} tickFormatter={value => `$${value}M`} data-id="element-1079" />
              <Tooltip formatter={(value: any) => `$${Number(value).toFixed(1)}M`} contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              padding: '12px'
            }} data-id="element-1080" />
              <Area type="monotone" dataKey="revenue" stroke="#4f46e5" strokeWidth={3} fillOpacity={1} fill="url(#colorRevenue)" activeDot={{
              r: 6,
              fill: '#4f46e5',
              stroke: '#fff',
              strokeWidth: 2
            }} data-id="element-1081" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Trade Payment Information */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8" data-id="element-1082">
        {/* Trade Credit */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-2" data-id="element-1083">
          <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-1084">
            Trade Credit
          </h2>
          <div className="grid grid-cols-2 gap-x-8 gap-y-8" data-id="element-1085">
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1086">
              <span className="text-3xl font-bold text-gray-900 mb-1" data-id="element-1087">
                $50K
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1088">
                Recommended Credit Limit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1089">
              <span className="text-3xl font-bold text-gray-900 mb-1" data-id="element-1090">3</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1091">
                Days Beyond Terms
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1092">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1093">142</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1094">
                Trade Experiences
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1095">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1096">
                $1.85M
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1097">
                Total Trades Balance
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1098">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1099">
                $275K
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1100">
                Recent High Credit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1101">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1102">
                $13.0K
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1103">
                Average Credit Amount
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1104">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1105">
                $12.5K
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1106">
                Past Due
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1107">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1108">
                0.7%
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1109">
                Past Due %
              </span>
            </div>
            <div className="flex flex-col" data-id="element-1110">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1111">$0</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1112">
                Severely Past Due
              </span>
            </div>
            <div className="flex flex-col" data-id="element-1113">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1114">0%</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1115">
                Severely Past Due %
              </span>
            </div>
          </div>
        </div>

        {/* Days Beyond Terms Chart */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 flex flex-col lg:col-span-3" data-id="element-1116">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-4 gap-4" data-id="element-1117">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-1118">
              Days Beyond Terms
            </h2>
            <div className="flex flex-wrap items-center gap-4 text-sm bg-gray-50 px-4 py-2 rounded-lg border border-gray-100" data-id="element-1119">
              <div className="flex items-center gap-2" data-id="element-1120">
                <div className="w-6 h-0.5 border-t-2 border-dashed border-gray-400" data-id="element-1121"></div>
                <span className="font-medium text-gray-600" data-id="element-1122">Industry</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1123">
                <div className="w-6 h-0.5 bg-gray-900" data-id="element-1124"></div>
                <span className="font-medium text-gray-900" data-id="element-1125">DBT</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1126">
                <div className="w-6 h-0.5 bg-indigo-600" data-id="element-1127"></div>
                <span className="font-medium text-indigo-600" data-id="element-1128">Your AR</span>
              </div>
            </div>
          </div>
          <p className="text-sm text-gray-500 mb-8 max-w-md leading-relaxed" data-id="element-1129">
            Compare how they pay the industry, how they pay their vendors
            generally, and how they pay you.
          </p>
          <div className="flex-1 min-h-[250px] w-full mt-auto" data-id="element-1130">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1131">
              <LineChart data={dbtData} margin={{
              top: 5,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-1132">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1133" />
                <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} dy={10} data-id="element-1134" />
                <YAxis axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} domain={[0, 15]} ticks={[0, 5, 10, 15]} data-id="element-1135" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                padding: '12px'
              }} data-id="element-1136" />
                <Line type="monotone" dataKey="industry" name="Industry" stroke="#9ca3af" strokeWidth={2} strokeDasharray="5 5" dot={false} activeDot={{
                r: 6,
                fill: '#9ca3af'
              }} data-id="element-1137" />
                <Line type="monotone" dataKey="dbt" name="DBT" stroke="#111827" strokeWidth={2} dot={false} activeDot={{
                r: 6,
                fill: '#111827'
              }} data-id="element-1138" />
                <Line type="monotone" dataKey="yourAR" name="Your AR" stroke="#4f46e5" strokeWidth={3} dot={false} activeDot={{
                r: 6,
                fill: '#4f46e5'
              }} data-id="element-1139" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Trade Payment Aging */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-1140">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 gap-4" data-id="element-1141">
          <div data-id="element-1142">
            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1143">
              Trade Payment Information
            </h2>
            <div className="flex items-center gap-3 text-sm" data-id="element-1144">
              <span className="font-medium text-gray-900 bg-gray-100 px-2.5 py-1 rounded-md" data-id="element-1145">
                Total Trade Lines: 142
              </span>
              <span className="text-gray-500" data-id="element-1146">
                Updated Monthly - Next Update 04/01/2026
              </span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto mb-10 border border-gray-200 rounded-xl" data-id="element-1147">
          <table className="w-full text-left border-collapse" data-id="element-1148">
            <thead data-id="element-1149">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1150">
                <th className="px-6 py-4 text-sm font-bold text-gray-900" data-id="element-1151">
                  Status
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1152">
                  Current
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1153">
                  1-30
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1154">
                  31-60
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1155">
                  61-90
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1156">
                  91+
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-100" data-id="element-1157">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1158">
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-1159">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-1160">
                  Paid
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1161">
                  $28,500,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1162">
                  $1,200,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1163">
                  $85,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1164">
                  $12,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1165">
                  $3,000
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-1166">
                  $29,800,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-1167">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-1168">
                  Outstanding
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1169">
                  $1,650,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1170">
                  $180,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1171">
                  $15,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1172">
                  $5,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1173">
                  $0
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-1174">
                  $1,850,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-1175">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-1176">
                  Payment Experiences
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1177">
                  112
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1178">
                  22
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1179">
                  5
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1180">
                  2
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1181">
                  1
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-1182">
                  142
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Bar Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-1183">
          {/* Paid Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1184">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-1185">
              <div className="w-2 h-6 bg-green-600 rounded-full" data-id="element-1186"></div>
              Paid History
            </h3>
            <div className="h-64 w-full" data-id="element-1187">
              <ResponsiveContainer width="100%" height="100%" data-id="element-1188">
                <BarChart data={paidData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-1189">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1190" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-1191" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-1192" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(1)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-1193" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '31-60') fill = '#84cc16';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-1195" />;
                }} data-id="element-1194" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Outstanding Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1196">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-1197">
              <div className="w-2 h-6 bg-blue-600 rounded-full" data-id="element-1198"></div>
              Outstanding Balance
            </h3>
            <div className="h-64 w-full" data-id="element-1199">
              <ResponsiveContainer width="100%" height="100%" data-id="element-1200">
                <BarChart data={outstandingData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-1201">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1202" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-1203" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-1204" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(2)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-1205" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '31-60') fill = '#84cc16';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-1207" />;
                }} data-id="element-1206" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      {/* Trade Spend by Industry Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1208">
        {/* Trade Spend Donut Chart */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-1" data-id="element-1209">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1210">
            Trade Spend by Industry
          </h2>
          <div className="relative h-64 w-full mb-8" data-id="element-1211">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1212">
              <PieChart data-id="element-1213">
                <Pie data={tradeSpendData} cx="50%" cy="50%" innerRadius={70} outerRadius={100} paddingAngle={2} dataKey="value" stroke="none" data-id="element-1214">
                  {tradeSpendData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1215" />)}
                </Pie>
                <Tooltip formatter={(value: any) => `$${(value / 1000).toFixed(0)}K`} contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }} data-id="element-1216" />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-1217">
              <span className="text-2xl font-black text-gray-900" data-id="element-1218">$1.85M</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1219">
                Total Spend
              </span>
            </div>
          </div>

          {/* Custom Legend */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-1220">
            {tradeSpendData.map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-1221">
                <div className="w-3 h-3 rounded-full" style={{
              backgroundColor: item.color
            }} data-id="element-1222"></div>
                <span className="text-sm text-gray-600" data-id="element-1223">
                  {item.name} {item.percentage}%
                </span>
              </div>)}
          </div>
        </div>

        {/* Payment Aging by Industry */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-2" data-id="element-1224">
          <div className="flex justify-between items-center mb-8" data-id="element-1225">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-1226">
              Payment Aging by Industry
            </h2>
            <div className="flex bg-gray-100 rounded-lg p-1" data-id="element-1227">
              <button className="px-3 py-1 text-sm font-medium bg-white shadow-sm rounded-md text-gray-900" data-id="element-1228">
                %
              </button>
              <button className="px-3 py-1 text-sm font-medium text-gray-500 hover:text-gray-900" data-id="element-1229">
                $
              </button>
            </div>
          </div>

          <div className="space-y-6" data-id="element-1230">
            {paymentAgingData.map((item, index) => <div key={index} className="flex flex-col gap-2" data-id="element-1231">
                <div className="flex justify-between items-end" data-id="element-1232">
                  <span className="text-sm font-medium text-gray-700" data-id="element-1233">
                    {item.industry}
                  </span>
                  <span className="text-sm text-gray-500" data-id="element-1234">
                    {item.total} ({item.trades})
                  </span>
                </div>
                {/* Stacked Bar */}
                <div className="h-6 w-full flex rounded-sm overflow-hidden" data-id="element-1235">
                  {item.current > 0 && <div style={{
                width: `${item.current}%`
              }} className="bg-[#16a34a] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1236">
                      {item.current > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1237">
                          {item.current}%
                        </span>}
                    </div>}
                  {item.days1to30 > 0 && <div style={{
                width: `${item.days1to30}%`
              }} className="bg-[#84cc16] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1238">
                      {item.days1to30 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1239">
                          {item.days1to30}%
                        </span>}
                    </div>}
                  {item.days31to60 > 0 && <div style={{
                width: `${item.days31to60}%`
              }} className="bg-[#facc15] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1240">
                      {item.days31to60 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1241">
                          {item.days31to60}%
                        </span>}
                    </div>}
                  {item.days61to90 > 0 && <div style={{
                width: `${item.days61to90}%`
              }} className="bg-[#f59e0b] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1242">
                      {item.days61to90 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1243">
                          {item.days61to90}%
                        </span>}
                    </div>}
                  {item.days91plus > 0 && <div style={{
                width: `${item.days91plus}%`
              }} className="bg-[#dc2626] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1244">
                      {item.days91plus > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1245">
                          {item.days91plus}%
                        </span>}
                    </div>}
                </div>
              </div>)}
          </div>

          <div className="mt-8 text-center border-t border-gray-100 pt-4" data-id="element-1246">
            <button className="text-indigo-600 text-sm font-medium hover:text-indigo-700 uppercase tracking-wider" data-id="element-1247">
              Show More
            </button>
          </div>
        </div>
      </div>
    </div>;
}